import { createSelector } from 'reselect';
import { INFO } from './actions';

export const getMessage = (state, props) => state.getIn(
  ['form', 'messages', (props && props.slotId) ? props.slotId : 'default']
);

export const getType = createSelector(
  getMessage,
  message => ((message) ? message.messageType : INFO)
);

export const getFieldErrors = createSelector(
  getMessage,
  message => ((message) ? message.fieldErrors : {})
);
